module.exports = __webpack_public_path__ + "img/monoquant.03c5f7cf.svg";